import { FuelIcon, FuelTypography } from '@frete.com/fuel-react';
import React from 'react';
import * as Styled from './styled';

export const RatingAndTrips: React.FC<{
  rate: number;
  ammountTravelled: number;
  scrolledValue: number;
  isSmallProfile: boolean;
}> = ({ rate, ammountTravelled, isSmallProfile, scrolledValue }) => {
  const getHasEvaluation = () => !Number.isNaN(rate) && rate > 0;
  const hasEvaluation = getHasEvaluation();

  const getAmmountTravelledText = () => {
    if (!ammountTravelled || ammountTravelled === 0) return 'Sem viagens';
    return `${ammountTravelled} ${ammountTravelled === 1 ? 'viagem' : 'viagens'}`;
  };

  const getRateText = () => (hasEvaluation ? rate : 'Sem avaliação');

  const ammountTravelledText = getAmmountTravelledText();
  const rateText = getRateText();

  return (
    <Styled.RatingAndTrips
      isSmallProfile={isSmallProfile}
      scrolledValue={scrolledValue}
      data-testid="rate-and-trips-wrapper"
    >
      <FuelIcon name="star" size="micro" iconStyle="filled" />
      <FuelTypography weight="medium" color="neutral-default" size="body-sm" data-testid="rate-and-trips-text">
        {rateText} • {ammountTravelledText}
      </FuelTypography>
    </Styled.RatingAndTrips>
  );
};
